<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mt-2 mb-3">
        <li>
          <router-link to="/holiday-management" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("system.label.CreateHoliday") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <vx-card>
          <div class="vx-row mt-2">
            <div class="vx-col md:w-1/2">
              <vs-checkbox v-model="isWeeklyHoliday">
                Is Weekly Holiday?
              </vs-checkbox>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.HolidayTitle')"
              >
                <vs-input
                  :label="$t('system.label.HolidayTitle')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="holidayTitle"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <ValidationProvider
                rules="required"
                v-slot="{ errors }"
                :name="$t('system.label.Description')"
              >
                <vs-input
                  :label="$t('system.label.Description')"
                  class="w-full mb-2 font-semibold starlabel"
                  v-model="description"
                />
                <span class="validate-error" style="color: red">{{
                  errors[0]
                }}</span>
              </ValidationProvider>
            </div>
          </div>
          <div class="vx-row mt-2">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.HolidayType") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.HolidayType')"
                >
                  <v-select
                    label="username"
                    v-model="holidayType"
                    :options="holidayTypeList || []"
                    :reduce="(obj) => obj"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    @input="onChangeHolidayType"
                    class="min-w-200 w-full"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("system.label.entity") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="`${$t('system.label.entity')}`"
                >
                  <v-select
                    label="name"
                    v-model="offices"
                    multiple
                    :options="officeList || []"
                    :reduce="(obj) => obj.id"
                    :placeholder="$t('placeholder.label.SelectOne')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  >
                  </v-select>
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div v-if="isWeeklyHoliday" class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="weekly-box">
                <div class="weekly-label">
                  Select Days <span class="required">*</span>
                </div>
                <div class="weekly-days">
                  <vs-checkbox
                    v-for="day in daysList"
                    :key="day"
                    v-model="daySelection[day]"
                    :val="day"
                  >
                    {{ day }}
                  </vs-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isWeeklyHoliday" class="vx-row">
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.StartDate") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.StartDate')"
                >
                  <Datepicker
                    placeholder="Select Date"
                    v-model="startDate"
                    class="font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-col w-full lg:w-1/2 md:w-1/2 sm:w-full xs:w-full">
              <div class="dropdown-with-label">
                <small class="date-label"
                  >{{ $t("setup.label.EndDate") }}
                  <span class="required">*</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('setup.label.EndDate')"
                >
                  <Datepicker
                    placeholder="Select Date"
                    v-model="endDate"
                    class="font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-row center">
        <div class="vx-col w-full">
          <vs-button
            color="primary"
            type="border"
            class="mb-2 footerButton-cancel"
            @click="cancel"
            >{{ $t("setup.label.Cancel") }}</vs-button
          >
          <vs-button
            class="mr-3 mb-2 footerButton-next"
            @click="createholiday"
            >{{ $t("setup.label.Submit") }}</vs-button
          >
        </div>
      </div>
    </ValidationObserver>
    <validation-popup
      :errorMessage="errorMessage"
      :warningPopup="warningPopup"
      :warningText="warningText"
      @closeWarning="warningPopup = false"
    ></validation-popup>
  </div>
</template>
<script>
import vSelect from "vue-select";
import { mapState } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import ValidationPopup from "@/components/ValidationPopup.vue";

export default {
  data() {
    return {
      warningPopup: false,
      warningText: "",
      errorMessage: "",
      holidayTitle: "",
      holidayType: "",
      startDate: "",
      endDate: "",
      offices: "",
      description: "",
      officeList: [],
      holidayTypeList: ["Public Holiday", "Company Holiday", "Weekly Holiday"],
      isWeeklyHoliday: false,
      daySelection: {
        Sunday: false,
        Monday: false,
        Tuesday: false,
        Wednesday: false,
        Thursday: false,
        Friday: false,
        Saturday: false,
      },
      daysList: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      rawOfficeList: [],
    };
  },
  components: {
    "v-select": vSelect,
    "validation-popup": ValidationPopup,
    ValidationProvider,
    ValidationObserver,
    Datepicker,
  },
  computed: {
    ...mapState({
      sessionList: (state) => state.shiftManagement.sessionList,
    }),
    weeklyDays() {
      return Object.keys(this.daySelection).filter(
        (day) => this.daySelection[day]
      );
    },
  },
  methods: {
    async createholiday() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;
      const payload = {
        locale: "en",
        dateFormat: "dd MMMM yyyy",
        name: this.holidayTitle,
        description: this.description,
        holidayType: this.holidayType,
        offices: this.offices.map((id) => ({ officeId: id })),
        isWeeklyHoliday: this.isWeeklyHoliday,
      };
      if (this.holidayType == "Public Holiday") {
        payload.offices = [{ officeId: 0 }];
      }
      if (this.isWeeklyHoliday) {
        payload.weeklyHolidayDays = this.weeklyDays;
      } else {
        payload.fromDate = moment(this.startDate).format("DD MMMM YYYY");
        payload.toDate = moment(this.endDate).format("DD MMMM YYYY");
      }
      try {
        await this.$store.dispatch(
          "holidayManagement/createHolidayAction",
          payload
        );
        if (this.sessionList) {
          this.$swal({
            title: "Success",
            icon: "success",
            text: "Holiday Created Successfully!",
            type: "success",
          });
          this.$router.push(`/holiday-management`);
        }
      } catch (error) {
        const errorMessage = String(error).replace(/^Error:\s*/, "");
        this.$swal({
          title: "Error",
          icon: "error",
          html: `<div style="text-align: center;">${errorMessage}</div>`,
          type: "error",
        });
      }
    },
    async getSessionMcodesMethod() {
      try {
        await this.$store.dispatch("shiftManagement/getSessionMcodesAction");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    cancel() {
      this.$router.push(`/holiday-management`);
    },
    onChangeHolidayType() {
      this.offices = "";
    },
    async getTemplateData() {
      try {
        const response = await this.$store.dispatch(
          "users/getUserTemplateData"
        );
        this.rawOfficeList =
          response && response.data && response.data.allowedOffices;
        this.officeList = [
          { id: 0, name: "All Offices", nameDecorated: "All Offices" },
          ...this.rawOfficeList,
        ];
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
  },
  watch: {
  },
  async mounted() {
    this.getTemplateData();
    await this.getSessionMcodesMethod();
  },
};
</script>
<style>
.weekly-box {
  position: relative;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 20px 16px 12px;
  margin-top: 8px;
  background-color: white;
}

.weekly-label {
  position: absolute;
  top: -10px;
  left: 8px;
  background: white;
  padding: 0 4px;
  font-size: 14px;
  color: #777777;
  font-weight: 600;
}

.weekly-days {
  display: flex;
  flex-wrap: wrap;
  gap: 11px;
}
</style>
